<button class="app-button" (click)="handleClick($event)" pButton [severity]="status" [type]="type" [disabled]="disabled" [pTooltip]="tooltip" [tooltipDisabled]="!tooltip">
  <!-- <div  style="padding-right: 5px; width: 20px">
    <app-loading-dots size="3px"></app-loading-dots>
  </div> -->
  <app-loading-dots size="4px" style="padding-right: 10px; display: inline-block;" *ngIf="isProcessing"></app-loading-dots>

  <ng-content></ng-content>
</button>
